export default class CustomerGroup4ManagementColumnModel {
	static CustomerGroup4ManagementColumn = [
	  {
		  title: 'Customer group 4',
		  align: 'left',
		  field: 'group4Name'
	  }
	]
}
